export enum LobbyStatus {
	Upcoming = 'upcoming',
	Active = 'active',
	Closed = 'closed',
}
